/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import OocyteSelector from './occyteSelector';
import DetailsTable from './detailsTable';
import { action945Items, actionOptionsLocalized, cryoPurposeOptionsLocalized, EmbryoDetail, EmbryoFinilizeUpdateType, EmbryoOocyteFilledStatus, FreezeDialogValues, freezelocationDetails,  incubatorItems, initialValuesCryo, source_list, storeGobletColor, UpdateEmbryo, useIncubatorsDropdown } from './embryoCulture.helpers';
import { Autocomplete, Box, Button, Grid2, TextField, ThemeProvider, Typography } from '@mui/material';
import styles from './embryoCulture.module.css';
import { theme } from '../../../components/Medical_History_Forms/themeprovider';
import { Form } from 'react-router-dom';
import { Formik, FormikErrors, FormikHelpers, getIn } from 'formik';
import { convertUnderscoreToTitle, getCurrentTimeHHMM, getLocalizedLabelByCode, RequiredLabel } from '../../../utils/commonUtils';
import { Clinician, fetchIncubators, IncubatorObject, mediaOptionsLocalized, Role, ROLES } from '../Occyte-Grading/oocyteGrading.helper';
import { useClinic } from '../../../components/ClinicProvider';
import { useAlert } from '../../../components/alertProvider';
import { useLoader } from '../../../components/loaderProvider/loader';
import { getUsersByClinicId } from '../../../services/apiService';
import ImageUploadComponent from '../../../components/Surgery/laparoscopy/imageUploadLaparoscopy';
import { ConfirmationModal } from '../../../components/confirmationModal';
import { CombinedValidationSchema, EmbryoCultureType, EmbryoUpdateDetailsType, getColumns, getEmbryoCultureDetails,  initialEmbryoCultureValues, initialEmbryoUpdateValues, updateEmbryoDetails, updateEmbryoSummaryDetails } from './dayTwo.helpers';
import { AxiosError } from 'axios';
import GradingUnavailable from '../Occyte-Grading/oocyteGradingUnavailable';
import EmbryoCultureViewMode from './ViewMode';
import FreezeActionDialog from './freezeActionDialog';
import OverlayIconPanel from './overlay';
import EmbryoFileUpload from './EmbryoFileUpload';
import EmbryoMultiImageUploadDialog from './EmbryoMultiImageUploadDialog';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { EmbryoDetailsMasters } from './dayFirst.helpers';
import { getButtonStates } from '../../../utils/permissionService'; 
import { useTranslation } from 'react-i18next';
import { getFreezeSlotProps  } from '../../../utils/getFreezeSlotProps';

 
interface cycleProp {
  initialCycleId: number;
  dropDownMaster : EmbryoDetailsMasters
}

const DayTwo:React.FC<cycleProp> = ({ initialCycleId,dropDownMaster }) => {
  const { t: tGeneral, i18n } = useTranslation('general');  
  const language = i18n.language;
  const { t: tCulture } = useTranslation('culture_config');  
  const { ClinicId } = useClinic();
  const { addAlert } = useAlert();
  const { showLoader, hideLoader } = useLoader();
  const [file, setFile] = useState<File | null>(null); 
  const [imagePathUrl, setImagePathUrl] = useState<string | null>(null);
  const [selectedEmbryos, setSelectedEmbryos] = useState<number[]>([]);
  const [selectedSource, setselectedSource] = useState<string>('');
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [hitSubmitbtn, setHitSubmitbtn] = useState(false);
  const [embryoCulture, setEmbryoCulture] = useState<EmbryoCultureType>(initialEmbryoCultureValues);
  const [embryoDetails, setEmbryoDetails] = useState<EmbryoUpdateDetailsType>(initialEmbryoUpdateValues);
  const [embryosFound, setEmbryosFound] = useState<boolean>(true); 
  const [allSourceEmbryos, setAllSourceEmbryos] = useState<UpdateEmbryo[]>([]);
  const [actionStatus, setActionStatus] = useState<'DRAFT' | 'FINALIZED'>('DRAFT');
  // Initialize state for clinician lists
  const [clinicianLists, setClinicianLists] = useState<Record<Role, Clinician[]>>({
    DOCTOR: [],
    ANESTHETIST: [],
    EMBRYOLOGIST: [],
    NURSE: [],
  });
  const [allEmbryos, setAllEmbryos] = useState<EmbryoDetail[]>([]);
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [tableData, setTableData] = useState<any[]>([]);
  const [isTableDeletable, setIsTableDeletable] = useState(true);
  const [showViewMode, setShowViewMode] = useState(false);
  const { canAdd, canEdit, canView } = getButtonStates('Lab', 'Embryo Culture', 'Day 2', 'female');
  

  const [freezeValues, setFreezeValues] = useState<FreezeDialogValues>(initialValuesCryo);
  const [isFreezeDialogOpen, setFreezeDialogOpen] = useState(false);
  
  const [areAllOocytesFilled, setAreAllOocytesFilled] = useState(false);
  const [isFinalizeConfirmDialogOpen, setFinalizeConfirmDialogOpen] = useState(false);
  
  const [selectedCycleId, setSelectedCycleId] = useState<number>(initialCycleId);
  const [sourceData, setSourceData] = useState<source_list[]>([]);
  const [selectedSourceId, setSelectedSourceId] = useState<number | null>(null);
  const [selectedThawId, setSelectedThawId] = useState<number | null>(null);
  const [uploadedFiles, setUploadedFiles] = useState<{ embryo_no: number; base64: string }[]>([]);
  const [isEmbryoUploadDialogOpen, setEmbryoUploadDialogOpen] = useState(false); // State to control Embryo upload dialog visibility
  const [freezeLocations, setFreezelocations]= useState<freezelocationDetails[]|null>(null);
  const [incubatorsDropdown, refreshIncubators] = useIncubatorsDropdown('Embryo');
  const [detailFound, setDetailFound] = useState<boolean>(false); 
  
  useEffect(() => {
    refreshIncubators();
  }, [tGeneral, refreshIncubators]);

  const fetchEmbryoDetails = useCallback(
    (cycle_id: number,  sourceID?: number, thawId?:number | null) => {
      showLoader();
      if (cycle_id) {
        getEmbryoCultureDetails(cycle_id, sourceID, thawId) 
          .then((data) => {
            const dayOneEntry = data?.details.find((item: { day: number; }) => item.day === 2);   
            
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const embryoDetails = data.embryo.map((detail: any) => ({
              embryo_number: detail.embryo_number,
              isFilled: detail.action !== null,
            }))
              .sort((a: { embryo_number: number; }, b: { embryo_number: number; }) => a.embryo_number - b.embryo_number);
            setAllEmbryos(embryoDetails);  

            if (data.embryo && data.embryo.length === 0) {

              setEmbryosFound(false); 
            } else {
              setEmbryosFound(true); 
            }


            // const finalizedItem = data.embryo?.find((item: EmbryoUpdateDetailsType) => item.status === 'FINALIZED');            
            // setIsTableDeletable(!finalizedItem);
            
            // if (embryoDetails.length >= 1) {
            //   const isAllFilled = embryoDetails.every((embryo: EmbryoOocyteFilledStatus) => embryo.isFilled);                    
            //   if (!isAllFilled) {
            //     setAreAllOocytesFilled(false);
            //   } else {
            //     setAreAllOocytesFilled(true);
            //   }
            // } else {
            //   setAreAllOocytesFilled(false);
            // }

            const opuDate = dayOneEntry.opu_date;               
            const thawDate = data?.details[0].thaw_date;
            
            const adjustedDate = opuDate
              ? new Date(new Date(opuDate).getTime() + 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
              : thawDate 
                ? new Date(thawDate).toISOString().split('T')[0]
                : new Date().toISOString().split('T')[0];
            
            setEmbryoCulture((prevEmbryoCulture) => ({
              ...prevEmbryoCulture,  
              ...dayOneEntry,
              opu_date: adjustedDate           
            }));

            
            const found = !!(data?.details && data.details[0] && data.details[0].embryologist);
            setDetailFound(found);

          })
          .catch((error) => {
            console.error('Error fetching Embryo Details:', error);
          })
          .finally(() => {
            hideLoader();
          });
      }
    },
    [showLoader, hideLoader]
  );

  const fetchSourceList = useCallback((isdeletetriggered?:boolean)=>{
    getEmbryoCultureDetails(selectedCycleId)
      .then((data) => {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        processEmbryoData(data,selectedSourceId, selectedThawId );
        // Check if source_list exists before updating state
        if (data && Array.isArray(data.source_list)) {
          setSourceData(data.source_list);
          // Set the first object's source as the selectedSourceId if sourceData is not empty
          if (data.source_list.length > 0) {
  
            const firstSourceId = data.source_list[0].source;
            const FirstThawId = data.source_list[0].thaw_cycle;
            setselectedSource(data.source_list[0].name);
            setSelectedSourceId(firstSourceId);
            setSelectedThawId(FirstThawId);
            // Call fetchEmbryoDetails with the first source ID
            fetchEmbryoDetails(selectedCycleId, firstSourceId, FirstThawId);
          }
          setAllSourceEmbryos(data.embryo);
  
          const finalizedItem = data.embryo?.every((item: EmbryoUpdateDetailsType) => item.status === 'FINALIZED');            
          setIsTableDeletable(finalizedItem);


          if (!isdeletetriggered) {
                   
            const showViewMode = data.embryo?.some((item: EmbryoUpdateDetailsType) => item.action !== null);
            setShowViewMode(showViewMode);
                           
          } else {
            setShowViewMode(false);
          }

          const embryoDetails = data.embryo
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((detail: any) => ({
              embryo_number: detail.embryo_number,
              isFilled: detail.action !== null,
            }))
            .sort((a: { embryo_number: number; }, b: { embryo_number: number; }) => a.embryo_number - b.embryo_number);
                          
          if (embryoDetails.length >= 1) {
            const isAllFilled = embryoDetails.every((embryo: EmbryoOocyteFilledStatus) => embryo.isFilled);
                      
            if (!isAllFilled) {
              setAreAllOocytesFilled(false);
            } else {
              setAreAllOocytesFilled(true);
            }
          } else {
            setAreAllOocytesFilled(false);
          }            
        }
      })
      .catch((error) => {
        console.error('Error fetching source list:', error);
      });
    // eslint-disable-next-line
  },[]);

  useEffect(() => {
    fetchSourceList();
    // eslint-disable-next-line
  }, [selectedCycleId]);
    
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const processEmbryoData = (data:any, selectedSourceId:number |null |undefined, selectedThawId:number |null |undefined) => {


    // if (data.details && Array.isArray(data.details)&& !selectedSourceId && !selectedThawId) {
    //   const mappedRows = data.embryo
    //     // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //     .filter((item: any) => item.action !== null).sort((a: any, b: any) => a.embryo_number - b.embryo_number).map((item: any) => {
    //       const freezeContent = item.action === 'FREEZE'
    //         ? {
    //           title: 'Action Information',
    //           details: [
    //             { label: 'Cryo Preserved date', value: item.cryo_preserved_date || '-' },
    //             { label: 'Cryo Preserved By', value: item.cryo_preserved_by_name || '-' },
    //             { label: 'Cryo Purpose', value: convertUnderscoreToTitle(item.cryo_purpose) || '-' },
    //             { label: 'Media', value: convertUnderscoreToTitle(item.cryo_media) || '-' },
    //             { label: 'Screening Status', value: item.is_screened  ?'Yes':'No'},
    //           ],
    //         }
    //         : null;
          
    //       console.log('itemitemitem',item);
            
    //       return{
            
    //         id: item.id,
    //         image:item.files_url,
    //         embryoNo: item.embryo_no,
    //         pn: item?.pn || '-',
    //         pb: item?.pb || '-',
    //         cleavage: convertUnderscoreToTitle(item?.cleavage) || '-',
    //         action: item.action === 'FREEZE' && freezeContent ?( 
    //           <div style={{ display: 'flex', alignItems: 'center' }}>
    //             <OverlayIconPanel content={freezeContent} />
    //             <span style={{ marginLeft: '5px' }}>{convertUnderscoreToTitle(item.action)}</span>
    //           </div>): convertUnderscoreToTitle(item.action),
    //         freezeLocation: '-',
    //       };
    //     });

    //   setTableData(mappedRows);
    // }
    if (data.details && Array.isArray(data.details)&& !selectedSourceId && !selectedThawId) {
      const mappedRows = data.embryo
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .filter((item: any) => item.action !== null).sort((a: any, b: any) => a.embryo_number - b.embryo_number).map((item: any) => {
          const freezeContent = item.action === 'FREEZE'
            ? {
              title: tGeneral('actionInfoTitle', { defaultValue: 'Action Information' }),
              details: [
                { label: tGeneral('cryoPreservedDate', { defaultValue: 'Cryo Preserved Date' }), value: item.cryo_preserved_date ?? '-' },
                { label: tGeneral('cryoPreservedBy', { defaultValue: 'Cryo Preserved By' }), value: item.cryo_preserved_by_name ?? '-' },
                { label: tGeneral('cryoPurpose', { defaultValue: 'Cryo Purpose' }), value: getLocalizedLabelByCode(cryoPurposeOptionsLocalized, item.cryo_purpose, language) ?? '-' },
                { label: tGeneral('media', { defaultValue: 'Media' }), value: getLocalizedLabelByCode(mediaOptionsLocalized, item.cryo_media, language) ?? '-' }, 
                { label: tGeneral('screeningStatus', { defaultValue: 'Screening Status' }), value: item.is_screened ? tGeneral('yes', { defaultValue: 'Yes' }) : tGeneral('no', { defaultValue: 'No' }) },
              ],
            }
            : null;
          return{
            id: item.id,
            embryoNo: item.embryo_no,
            image: item?.files[0]?.file,
            grade: item?.grade ?? '-',
            fragmentation_percentage: item?.fragmentation_percentage_label ?? '-',
            number_of_cells: item?.number_of_cells_label ?? '-',
            action: item.action === 'FREEZE' && freezeContent ?( 
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <OverlayIconPanel content={freezeContent} />
                <span style={{ marginLeft: '5px' }}>{ getLocalizedLabelByCode(actionOptionsLocalized, item.action, language) ?? '-' }</span>
              </div>): 
              getLocalizedLabelByCode(actionOptionsLocalized, item.action, language) ?? convertUnderscoreToTitle(item.action),
            freezeLocation: '-',
            
            location_details:item.location_details,
            embryo_number: item.embryo_number,
          };
          
        });

      setTableData(mappedRows);
    }
  };
  // Handle dropdown change using SelectChangeEvent type
  const handleSourceChange = (event: string) => {
    const selectedSOurceName = event;
    const selectedSourceItem = sourceData.find(item => item.name === selectedSOurceName) || null;
    // Log the selected source item
    setselectedSource(selectedSOurceName); // Update selectedSourceId as well
    
    // Use a default value if cycle is undefined
    const cycle_ID = selectedSourceItem?.cycle ?? 0; 
    setSelectedCycleId(cycle_ID);
    
    setSelectedSourceId(selectedSourceItem?.source ?? 0);
    setSelectedThawId(selectedSourceItem?.thaw_cycle ?? null);
    
    if (selectedSourceItem) {
      fetchEmbryoDetails(cycle_ID, selectedSourceItem.source, selectedSourceItem.thaw_cycle); 
    } 
  };
      
  const handleSelectionChange = (newSelectedOocytes: number[], newDropdownValue: string) => {    
    setSelectedEmbryos(newSelectedOocytes);
    if (selectedSource && selectedSource !== newDropdownValue) {      
      setselectedSource(newDropdownValue);
      handleSourceChange(newDropdownValue);
    };
  };
  
  useEffect(() => {
    setEmbryoCulture((prev) => ({
      ...prev,
      cycle: selectedCycleId,
    }));
  }, [selectedCycleId]);  
  
  // Wrap fetchCliniciansByRole in useCallback
  const fetchCliniciansByRole = useCallback((role: Role) => {
    showLoader();
    const query = `clinic=${ClinicId}&role=${role}`;
    getUsersByClinicId(query)
      .then((res) => {
        setClinicianLists(prev => ({ 
          ...prev,
          [role]: res?.objects ?? [],
        }));
      })
      .catch((error) => {
         
        console.error(`Error fetching ${role.toLowerCase()}s:`, error);
      })
      .finally(() => {
        hideLoader();
      });
  }, [ClinicId, showLoader, hideLoader]); // Add dependencies here
  
  // Fetch clinicians for each role on component mount or when ClinicId changes
  useEffect(() => {
    ROLES.forEach(fetchCliniciansByRole);
  }, [fetchCliniciansByRole]); 
  
  // Utility function to sanitize EmbryoCulture values
  const sanitizeEmbryoCulture = (values: EmbryoCultureType): EmbryoCultureType => {
    const sanitizedValues = { ...values };

    if (sanitizedValues.time && sanitizedValues.time.trim().length === 5) {
      sanitizedValues.time = `${sanitizedValues.time}:00`;
    }

    sanitizedValues.day = 2; 
    sanitizedValues.cycle = selectedCycleId; 

    return sanitizedValues;
  };

  const sanitizeEmbryoDetails = (values: EmbryoUpdateDetailsType,freezedetails?: freezelocationDetails): EmbryoUpdateDetailsType => {
    const sanitizedValues = { ...values };
    sanitizedValues.cycle = selectedCycleId; 
    sanitizedValues.status = 'FINALIZED';  
    if(sanitizedValues.action === 'FREEZE' && freezedetails){
      sanitizedValues.cryo_preserved_date = freezeValues.cryo_preserved_date || sanitizedValues.cryo_preserved_date;
      sanitizedValues.cryo_preserved_by = freezeValues.cryo_preserved_by || sanitizedValues.cryo_preserved_by;
      sanitizedValues.cryo_purpose = freezeValues.cryo_purpose || sanitizedValues.cryo_purpose;
      sanitizedValues.cryo_media = freezeValues.cryo_media || sanitizedValues.cryo_media;
      sanitizedValues.is_screened = freezeValues.is_screened || sanitizedValues.is_screened;
      sanitizedValues.locations = freezedetails.cryotech ?? null;
      sanitizedValues.embryos = [freezedetails.embryo_number];
    }
    
    sanitizedValues.source = selectedSourceId;
    sanitizedValues.thaw_cycle = selectedThawId;  
 
    // ✅ Add the uploaded files in the required format
    if (uploadedFiles.length > 0) {
      // ✅ Add the uploaded files in the required format
      sanitizedValues.files = uploadedFiles.map(file => ({
        embryo_no: file.embryo_no,
        file: file.base64.replace(/^data:image\/\w+;base64,/, '') // Remove prefix
      }));
    }
    

    return sanitizedValues;
  };

  const handleSubmit = async (
    values: { embryoCulture: EmbryoCultureType; embryoDetails: EmbryoUpdateDetailsType },
    { setSubmitting, setErrors, resetForm }: FormikHelpers<{
      embryoCulture: EmbryoCultureType;
      embryoDetails: EmbryoUpdateDetailsType;
    }>
  ) => {
    showLoader();
    if (freezeLocations){
      for (const location of freezeLocations) {
        const updatedFreezeValues = {
          goblet: location.goblet,
          goblet_color: location.goblet_color,
          cryotech: location.cryotech,
          cryotech_color: location.cryotech_color,
          embryo_number:location.embryo_number
        };
    
        // Inject these freeze values into your sanitize function
        const sanitizedEmbryoDetails = sanitizeEmbryoDetails({
          ...values.embryoDetails,
        }, updatedFreezeValues);
    
        const sanitizedEmbryoCulture = sanitizeEmbryoCulture({
          ...values.embryoCulture,
        });
        
    
        if (sanitizedEmbryoDetails.action === 'FREEZE') {
          const tank = location.plan;
    
          // Goblet color
          if (tank && location.goblet != null && location.goblet_color) {
            await storeGobletColor(tank, location.goblet, location.goblet_color)
              .then((response) => {
                console.log('Goblet color successfully stored.', response);
              })
              .catch((error) => {
                console.error('Error storing goblet color:', error);
              });
          } else {
            console.warn('Tank, Goblet, or Goblet Color is missing.');
          }
    
          // Cryotech color
          if (tank && location.cryotech != null && location.cryotech_color) {
            await storeGobletColor(tank, location.cryotech, location.cryotech_color)
              .then((response) => {
                console.log('Cryotech color successfully stored.', response);
              })
              .catch((error) => {
                console.error('Error storing cryotech color:', error);
              });
          } else {
            console.warn('Tank, Cryotech, or Cryotech Color is missing.');
          }
        }
  
        Promise.all([
          updateEmbryoDetails(values.embryoCulture.id ?? 0, sanitizedEmbryoCulture),
          updateEmbryoSummaryDetails(selectedCycleId, sanitizedEmbryoDetails),
        ])
          .then(([updatedEmbryoCulture, updatedEmbryoDetails]) => {
            addAlert(tGeneral('embryoSavedSuccess', { embryoNumber: location.embryo_number, defaultValue: 'Embryo {{embryoNumber}} saved successfully' }), 'success');

            // Reset form after each iteration if needed
            resetForm({
              values: {
                embryoCulture: sanitizedEmbryoCulture,
                embryoDetails: sanitizedEmbryoDetails,
              },
            });
    
            fetchEmbryoDetails(selectedCycleId, selectedSourceId ?? undefined, selectedThawId);
            fetchSourceList();
            setSelectedEmbryos([]);
          })
          .catch((error: unknown) => {
            if (error instanceof AxiosError) {
              if (error.response?.data?.type === 'validation_error') {
                const apiErrors = error.response.data.errors;
    
                const formikErrors: FormikErrors<{
                  embryoCulture: EmbryoCultureType;
                  embryoDetails: EmbryoUpdateDetailsType;
                }> = {
                  embryoCulture: {} as FormikErrors<EmbryoCultureType>,
                  embryoDetails: {} as FormikErrors<EmbryoUpdateDetailsType>,
                };
    
                apiErrors.forEach((err: { attr: string | null; detail: string }) => {
                  if (err.attr?.startsWith('embryoCulture')) {
                    const fieldKey = err.attr.replace('embryoCulture.', '');
                    formikErrors.embryoCulture![fieldKey as keyof EmbryoCultureType] = err.detail;
                  } else if (err.attr?.startsWith('embryoDetails')) {
                    const fieldKey = err.attr.replace('embryoDetails.', '');
                    formikErrors.embryoDetails![fieldKey as keyof EmbryoUpdateDetailsType] = err.detail;
                  } else {
                    console.error('Unhandled validation error:', err.detail);
                    addAlert(err.detail, 'error');
                  }
                });
    
                setErrors(formikErrors);
              } else {
                console.error('Unexpected error occurred:', error);
              }
            } else {
              console.error('Error occurred while saving embryo details:', error);
            }
          }).finally(() => {
            hideLoader();
            setSubmitting(false);
          });
      }
    }else{
      const sanitizedEmbryoCulture = sanitizeEmbryoCulture(values.embryoCulture);
      const sanitizedEmbryoDetails = sanitizeEmbryoDetails(values.embryoDetails); 
      Promise.all([
        updateEmbryoDetails(values.embryoCulture.id ?? 0, sanitizedEmbryoCulture),
        updateEmbryoSummaryDetails(selectedCycleId, sanitizedEmbryoDetails),
      ])
        .then(([updatedEmbryoCulture, updatedEmbryoDetails]) => {
          addAlert(tGeneral('embryoDetailsSavedSuccess', { defaultValue: 'Embryo details saved successfully' }), 'success');
       
          // Reset form with sanitized values
          resetForm({
            values: {
              embryoCulture: sanitizedEmbryoCulture,
              embryoDetails: sanitizedEmbryoDetails,
            },
          });
       
          // fetchEmbryoDetails(selectedCycleId ?? 0); 
  
          fetchEmbryoDetails(selectedCycleId,  selectedSourceId ?? undefined, selectedThawId);
          fetchSourceList(); 
          setSelectedEmbryos([]);
        })
        .catch((error: unknown) => {
          // Handle errors
          if (error instanceof AxiosError) {
            if (error.response?.data?.type === 'validation_error') {
              const apiErrors = error.response.data.errors;
       
              const formikErrors: FormikErrors<{
                   embryoCulture: EmbryoCultureType;
                   embryoDetails: EmbryoUpdateDetailsType;
                 }> = {
                   embryoCulture: {} as FormikErrors<EmbryoCultureType>,
                   embryoDetails: {} as FormikErrors<EmbryoUpdateDetailsType>,
                 };
  
              apiErrors.forEach((err: { attr: string | null; detail: string }) => {
                if (err.attr && err.attr.startsWith('embryoCulture')) {
                  const fieldKey = err.attr.replace('embryoCulture.', '');
                    formikErrors.embryoCulture![fieldKey as keyof EmbryoCultureType] = err.detail;
                } else if (err.attr && err.attr.startsWith('embryoDetails')) {
                  const fieldKey = err.attr.replace('embryoDetails.', '');
                    formikErrors.embryoDetails![fieldKey as keyof EmbryoUpdateDetailsType] = err.detail;
                } else {
                  console.error('Unhandled validation error:', err.detail);
                  
                  addAlert(err.detail, 'error');
                }
              });
       
              setErrors(formikErrors);
            } else {
              console.error('Unexpected error occurred:', error);
            }
          } else {
            console.error('Error occurred while saving embryo details:', error);
          }
        })
        .finally(() => {
          hideLoader();
          setSubmitting(false);
        });
    }
  };
  

  const handleDelete = (id: number | string) => {
    setTableData((prevRows) => prevRows.filter((row) => row.id !== id));
    fetchSourceList(true);

  };

  
  const saveFinalize = () => {
    const finalizePromises = sourceData.map((source) => {
      // Filter embryos that match the current source
      const filteredEmbryos = allSourceEmbryos
        .filter((embryo) => embryo.source === source.source && embryo.thaw_cycle === source.thaw_cycle)
        .map((embryo) => embryo.embryo_number);

      const payload: EmbryoFinilizeUpdateType = {
        embryos: filteredEmbryos,  
        cycle: selectedCycleId as number,
        day: 2, 
        status: 'FINALIZED',
        source:source.source,
        thaw_cycle:source.thaw_cycle
      };
      return updateEmbryoSummaryDetails(selectedCycleId, payload)
        .then(() => {
          addAlert(tGeneral('embryoDetailsSavedForSource', { sourceName: source.name, defaultValue: 'Embryo details for source {{sourceName}} saved successfully' }), 'success');
        })
        .catch((error) => {
          console.error(`Error finalizing embryo summary for source ${source.name}:`, error);
        });
    }); 
    Promise.all(finalizePromises).then(() => {
      fetchSourceList();
    }); 
  };

  
  const handleFreezeDialogSave = (formValues: FreezeDialogValues, selectedfreezedEmbryosDetails: freezelocationDetails[]) => {
    setFreezeValues(formValues); 
    setFreezelocations(selectedfreezedEmbryosDetails);
    setFreezeDialogOpen(false);
  };

  const handleUploadComplete = (files: { embryo_no: number; base64: string }[]) => {
    setUploadedFiles(files);
  };

  
  if (!canView) {
    return <GradingUnavailable message={tGeneral('youDoNotHaveAccessToViewPage', { defaultValue: 'You do not have access to view this page.' })} />;
  }

  
  if (showViewMode) {
    return (
      <div >
        <EmbryoCultureViewMode data={embryoCulture} tableData={tableData} isFinalized ={isTableDeletable} tablecolumns= {getColumns(tGeneral)} day={2} setIsEditMode={setShowViewMode}/> 
      </div>
    );
  };
  
  return (    
    <ThemeProvider theme={theme}>

      {!(canAdd || canEdit)? ( 
        <GradingUnavailable message={tGeneral('accessDeniedSaveData', { defaultValue: 'You do not have access to save data.' })} />
      ) : allEmbryos.length === 0 ? (
        <GradingUnavailable message={tCulture('noEmbryosAvailable', { defaultValue: 'No embryos available for the selected day.' })} />
      ) : (
        <Formik          
          initialValues={{ 
            embryoCulture: { 
              ...embryoCulture, 
              time: !embryoCulture.time ? getCurrentTimeHHMM() : embryoCulture.time, // Set current time only if empty
            }, 
            embryoDetails 
          }} 
          validationSchema={CombinedValidationSchema(tGeneral)}
          onSubmit={handleSubmit}          
          enableReinitialize={false}
        >
          {({
            values,
            setFieldValue,
            submitForm,
            validateForm,
            errors,
            touched,
            handleBlur,
            handleChange,
            setFieldTouched
          }) => {
            return (
              <Form>
                <Grid2 container spacing={2} marginTop={2}>
                  <Grid2 size={{xs:12, sm:3, md:3}}>
                    <TextField
                      name="date"
                      type="date"
                      label={RequiredLabel(tGeneral('Date', { defaultValue: 'Date' }), true)}
                      value={getIn(values, 'embryoCulture.opu_date') || ''}
                      disabled
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      defaultValue={new Date().toISOString().split('T')[0]}       
                    />
                  </Grid2>                
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <TextField
                      name="embryoCulture.time"
                      type="time"
                      label={RequiredLabel(tGeneral('time', { defaultValue: 'time' }), true)}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={getIn(values, 'embryoCulture.time') || ''}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        !!getIn(touched, 'embryoCulture.time') &&
                      !!getIn(errors, 'embryoCulture.time')
                      }
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      fullWidth
                      size="small"
                      id="embryologist"
                      options={clinicianLists['EMBRYOLOGIST'] || []}
                      getOptionLabel={(option) => `${option.first_name || ''} ${option.last_name || ''}`}
                      value={clinicianLists['EMBRYOLOGIST'].find(
                        (doctor) => doctor.id === values.embryoCulture?.embryologist
                      ) || null}
                      onChange={(_, value) => {
                        setFieldValue('embryoCulture.embryologist', value?.id || ''); // Update Formik's value for 'embryoCulture.embryologist'
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('embryologist', { defaultValue: 'Embryologist' }), true)}
                          error={
                            !!getIn(touched, 'embryoCulture.embryologist') &&
                          !!getIn(errors, 'embryoCulture.embryologist')
                          }
                        />
                      )}
                    />
                  </Grid2>
                    
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      fullWidth
                      size="small"
                      id="witness"
                      options={clinicianLists['EMBRYOLOGIST'] || []}
                      getOptionLabel={(option) => (option.first_name || '') + ' ' + (option.last_name || '')}
                      value={clinicianLists['EMBRYOLOGIST'].find(
                        (doctor) => doctor.id === values.embryoCulture?.witness
                      ) || null}
                      onChange={(_, value) => {
                        setFieldValue('embryoCulture.witness', value?.id || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('witness', { defaultValue: 'Witness' }), true)}
                          error={
                            !!getIn(touched, 'embryoCulture.witness') &&
                          !!getIn(errors, 'embryoCulture.witness')
                          }
                          helperText={
                            getIn(touched, 'embryoCulture.witness') && getIn(errors, 'embryoCulture.witness')
                              ? getIn(errors, 'embryoCulture.witness') === tGeneral('witnessEmbryologistNameIsRequired')
                                ? '': getIn(errors, 'embryoCulture.witness') : ''
                          }
                        />
                      )}
                    />
                  </Grid2>
      
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={incubatorsDropdown}
                      getOptionLabel={(option) => tGeneral(option.name_label)}
                      value={
                        incubatorsDropdown.find(
                          (option) => option.id === getIn(values, 'embryoCulture.incubator')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoCulture.incubator', value?.id || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('incubator', { defaultValue: 'Incubator' }), false)}
                          error={
                            !!getIn(touched, 'embryoCulture.incubator') &&
                          !!getIn(errors, 'embryoCulture.incubator')
                          }
                        />
                      )}
                    />
                  </Grid2>
      
                  <Grid2 size={{ xs: 12, sm: 3, md: 3 }}>
                    <TextField
                      name="remarks"
                      label={RequiredLabel(tGeneral('remark', { defaultValue: 'Remark' }), false)}
                      fullWidth
                      multiline
                      rows={1}
                      placeholder={tGeneral('enterRemark', { defaultValue: 'Enter remark' })}
                      value={values.embryoCulture?.remarks || ''}
                      onChange={(e) => {
                        setFieldValue('embryoCulture.remarks', e.target.value || '');
                      }}
                      onBlur={handleBlur}
                      error={
                        !!getIn(touched, 'embryoCulture.remarks') &&
                      !!getIn(errors, 'embryoCulture.remarks')
                      }
                    />
                  </Grid2>
                
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={dropDownMaster?.culture_dish_config}
                      getOptionLabel={(option) => option.label}
                      value={
                        dropDownMaster?.culture_dish_config.find(
                          (option) => option.value === getIn(values, 'embryoCulture.culture_dish_config')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoCulture.culture_dish_config', value?.value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('cultureDishConfig', { defaultValue: 'Culture Dish Configuration' }), false)}
                          error={
                            !!getIn(touched, 'embryoCulture.culture_dish_config') &&
                          !!getIn(errors, 'embryoCulture.culture_dish_config')
                          }
                        />
                      )}
                    />
                  </Grid2>              
                </Grid2>   
      
      
                <div>
                  <OocyteSelector
                    title={tGeneral('embryoNo', { defaultValue: 'Embryo No.'})}
                    sourceList={sourceData}
                    selectedsource={selectedSource}
                    totalOocytes={allEmbryos}
                    onSelectionChange={handleSelectionChange}
                    hitSubmitbtn={hitSubmitbtn}
                  />
                </div>
                <Grid2 container spacing={2} marginTop={2}>
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={dropDownMaster?.embryoDetails_grade}
                      getOptionLabel={(option) => option.label}
                      value={ dropDownMaster?.embryoDetails_grade.find((option) => option.value === getIn(values, 'embryoDetails.grade')) || null }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.grade', value?.value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('grade', { defaultValue: 'Grade' }), true)}
                          error={
                            !!getIn(touched, 'embryoDetails.grade') &&
                          !!getIn(errors, 'embryoDetails.grade')
                          }
                        />
                      )}
                    />
                  </Grid2>                
                
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={dropDownMaster?.fragmentation_percentage}
                      getOptionLabel={(option) => option.label}
                      value={
                        dropDownMaster?.fragmentation_percentage.find(
                          (option) => option.value === getIn(values, 'embryoDetails.fragmentation_percentage')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.fragmentation_percentage', value?.value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}                        
                          label={RequiredLabel(tGeneral('fragmentationPercentage', { defaultValue: '% Fragmentation' }), true)}
                          error={
                            !!getIn(touched, 'embryoDetails.fragmentation_percentage') &&
                          !!getIn(errors, 'embryoDetails.fragmentation_percentage')
                          }
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={dropDownMaster?.number_of_cells}
                      getOptionLabel={(option) => option.label}
                      value={
                        dropDownMaster?.number_of_cells.find(
                          (option) => option.value === getIn(values, 'embryoDetails.number_of_cells')
                        ) || null
                      }
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.number_of_cells', value?.value || '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tGeneral('numberOfCells', { defaultValue: '# Cells' }), true)}
                          error={
                            !!getIn(touched, 'embryoDetails.number_of_cells') &&
                          !!getIn(errors, 'embryoDetails.number_of_cells')
                          }
                        />
                      )}
                    />
                  </Grid2>
                
                  <Grid2 size={{ xs: 6, sm: 4, md: 4, lg: 3 }} >
                    <Autocomplete
                      options={action945Items}
                      getOptionLabel={(option) => tGeneral(option.label)}
                      value={
                        action945Items.find(
                          (option) => option.value === getIn(values, 'embryoDetails.action')
                        ) || null
                      }                   
                      onChange={(_, value) => {
                        setFieldValue('embryoDetails.action', value?.value || '');
                        if (value?.value === 'FREEZE') {
                          setFreezeDialogOpen(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          slotProps={getFreezeSlotProps(params, values, setFreezeDialogOpen)}
                          label={RequiredLabel(tGeneral('action', { defaultValue: 'Action' }), true)}
                          error={
                            !!getIn(touched, 'embryoDetails.action') &&
                            !!getIn(errors, 'embryoDetails.action')
                          }
                        />
                      )}
                    />
                  </Grid2>
                                    
                  <Grid2 size={{ xs: 2, sm: 2, md: 2, lg: 2 }}>
                    {/* <EmbryoFileUpload selectedEmbryos={selectedEmbryos} onFileUpload={setFile} imagePathUrl={imagePathUrl} cycle_id={selectedCycleId || null} day={2}/> */}
                    
                    <Button
                      variant="outlined"
                      component="span"
                      onClick={() => setEmbryoUploadDialogOpen(true)} // Open dialog on click
                      style={{
                        width: '10rem',
                        height: '36px',
                        padding: '12px 40px',
                        gap: '8px',
                        borderRadius: '10px',
                        background: 'rgba(243, 243, 243, 1)',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <FileUploadOutlinedIcon style={{ width: '20px', marginRight: '8px', color: 'black' }} />
                      <Typography
                        style={{
                          fontFamily: 'Montserrat',
                          fontSize: '16px',
                          fontWeight: '600',
                          lineHeight: '22px',
                          textAlign: 'left',
                          color: 'rgba(80, 80, 80, 1)',
                          textTransform: 'capitalize',
                        }}
                      >
                        {tGeneral('upload', { defaultValue: 'Upload' })}
                      </Typography>
                    </Button>

                    {/* Upload Dialog */}
                    <EmbryoMultiImageUploadDialog 
                      isOpen={isEmbryoUploadDialogOpen} 
                      onClose={() => setEmbryoUploadDialogOpen(false)} 
                      selectedEmbryos={selectedEmbryos} 
                      onUploadComplete={handleUploadComplete} 
                    />
                  </Grid2>
      
                  {/* Freeze Action Dialog */}
                  <FreezeActionDialog
                    open={isFreezeDialogOpen}
                    onClose={() => {
                      setFieldValue('embryoDetails.action', ''); 
                      setFreezeDialogOpen(false);  
                    }}
                    values={freezeValues}
                    onSave={handleFreezeDialogSave}                    
                    selectedEmbryos={selectedEmbryos}
                    existingFreezeLocations={freezeLocations || undefined}
                    defaultCryoPreservedDate={getIn(values, 'embryoCulture.opu_date') || undefined}
                  />
                  
                </Grid2>
      
                <div >
                  <p style={{fontFamily:'Montserrat', fontSize:'20px', fontWeight:700, padding:'1rem'}}>{tGeneral('details', { defaultValue: 'Details' })}</p>
                  <DetailsTable columns={getColumns(tGeneral)} rows={tableData} isDeletable={!showViewMode}  onDelete={handleDelete}/>
                </div>
                <div>
                  <Box sx={{display:'flex', justifyContent:'space-between'}}>
                    <Box sx={{display:'flex', justifyContent:'flex-start', marginTop:'1rem'}}>
                      {detailFound && (
                        <button
                          type="button"
                          className={styles.resetButton}
                          onClick={() => setShowViewMode(true)}
                        >
                          {tGeneral('Cancel', { defaultValue: 'Cancel' })}
                        </button>
                      )}
                    </Box>

                    <Box className={`${styles.customButtonDiv}`}  > 
                      {/* {!areAllOocytesFilled ? (
                        <button
                          type="button"
                          className={styles.resetButton}
                          style={{width:'10rem',
                            cursor : areAllOocytesFilled ? 'pointer':'not-allowed'
                          }}
                          disabled={!areAllOocytesFilled}
                          onClick={async () => {
                            setFieldValue('embryoDetails.cycle', selectedCycleId);
                    
                            // Ensure setFieldValue completes before proceeding
                            await setFieldValue('embryoDetails.embryos', selectedEmbryos);
                            setActionStatus('FINALIZED');

                            setHitSubmitbtn(true);
                            console.log('Embryo Details:', embryoDetails);
                    
                            validateForm().then((formErrors) => {
                              // Mark fields with validation errors as touched
                              Object.entries(formErrors).forEach(([namespace, fields]) => {
                                if (fields && typeof fields === 'object') {
                                  Object.keys(fields).forEach((field) => {
                                    setFieldTouched(`${namespace}.${field}`, true, true);
                                  });
                                }
                              });
                    
                              if (Object.keys(formErrors).length === 0) {
                                setOpenConfirmDialog(true);
                              } else {
                                console.log('Validation errors:', formErrors);
                              }
                            });
                          }}
                        >
                      Save & Finalize
                        </button>

                      ) : (
                        <button
                          type="button"
                          style={{ width: '10rem' }}
                          className={styles.resetButton}                          
                          onClick={() => setFinalizeConfirmDialogOpen(true)}
                        >
                          <span style={{ fontWeight: 'bold' }}>
                            {'Save & Finalized'}
                          </span>
                        </button>
                      )} */}

                      <button
                        type="button"
                        onClick={async () => {
                    
                          setFieldValue('embryoDetails.cycle', selectedCycleId);
                          // Ensure setFieldValue completes before proceeding
                          await setFieldValue('embryoDetails.embryos', selectedEmbryos);
                          setActionStatus('DRAFT');
                          setHitSubmitbtn(true);
                          validateForm().then((formErrors) => {
                          // Mark fields with validation errors as touched
                            Object.entries(formErrors).forEach(([namespace, fields]) => {
                              if (fields && typeof fields === 'object') {
                                Object.keys(fields).forEach((field) => {
                                  setFieldTouched(`${namespace}.${field}`, true, true);
                                });
                              }
                            });
                    
                            if (Object.keys(formErrors).length === 0) {
                              setOpenConfirmDialog(true);
                            } else {
                              console.log('Validation errors:2222', formErrors);
                            }
                          });
                        }}
                    
                        className={`${styles.customButton}`}
                      >
                        <span style={{ fontWeight: 'bold' }}>
                          {tGeneral('save', { defaultValue: 'Save' })}
                        </span>
                      </button>                 
                    </Box>
                  </Box>
                </div>
                  
                <ConfirmationModal
                  open={openConfirmDialog}
                  handleClose={() => setOpenConfirmDialog(false)}
                  onConfirm={() => {
                    setOpenConfirmDialog(false);
                    submitForm(); 
                  }} 
                  type="save"
                  title={tCulture('embryoCulture', { defaultValue: 'Embryo Culture' })}
                  contentMessage={
                    actionStatus === 'FINALIZED'
                      ? tCulture('confirmFinalizeDay2', { defaultValue: 'Are you sure you want to finalize day 2 details?' })
                      : tCulture('confirmSaveDay2', { defaultValue: 'Are you sure you want to save day 2 details?' })
                  }
                />
                
                <ConfirmationModal
                  open={isFinalizeConfirmDialogOpen}
                  handleClose={() => setFinalizeConfirmDialogOpen(false)}
                  onConfirm={() => {
                    setFinalizeConfirmDialogOpen(false);
                    saveFinalize();
                  }} 
                  type="save"
                  title={tCulture('embryoCulture', { defaultValue: 'Embryo Culture' })} 
                  contentMessage={ tCulture('confirmFinalizeDay2', { defaultValue: 'Are you sure you want to finalize day 2 details?' }) }
                />
                              
              </Form>
            );
          }}
        </Formik>
      )}
    </ThemeProvider>
  );
};

export default DayTwo;
